import api from './index'
import { axios } from '@/utils/request'

export function getIcon(parameter) {
  return axios({
    url: api.BaseURL + api.Icon + 'list_icon',
    method: 'GET',
    data: parameter
  })
}
